export { default } from './extractEventHandlers';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/extractEventHandlers/index.js
// module id = 190
// module chunks = 22